module.exports = __webpack_public_path__ + "img/MoveIn.377f9806.svg";